import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65fb1370&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconBell: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/icons/IconBell.vue').default,AlertsItem: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/alerts/item.vue').default})
